/* tslint:disable */
/* eslint-disable */

/**
 * 1 = Transporteur
 * 2 = Automatique
 */
export enum TypeClotureValues {
  Transporteur = 1,
  Automatique = 2
}
